


























































































































































































































  import { Component, Vue } from "vue-property-decorator";


@Component({
  components: {
  },
})
export default class PrivacyUs extends Vue {
  heavyCheckMark = '&#x2714;';

}
